import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { RecoilRoot } from "recoil";
import "./index.css"

const queryClient = new QueryClient();

const container = document.getElementById("root");

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <RecoilRoot>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>
);
